"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextResponseAdapter = exports.NextRequestAdapter = void 0;
var NextRequestAdapter = /** @class */ (function () {
    function NextRequestAdapter(request) {
        this.req = request;
    }
    NextRequestAdapter.prototype.setRequestCookie = function (name, value) {
        this.req.cookies[name] = value;
    };
    NextRequestAdapter.prototype.getHeader = function (name) {
        return this.req.headers[name];
    };
    return NextRequestAdapter;
}());
exports.NextRequestAdapter = NextRequestAdapter;
var NextResponseAdapter = /** @class */ (function () {
    function NextResponseAdapter(response) {
        this.res = response;
    }
    NextResponseAdapter.prototype.getHeader = function (name) {
        return this.res.getHeader(name);
    };
    NextResponseAdapter.prototype.setHeader = function (name, value) {
        this.res.setHeader(name, value);
        return this;
    };
    return NextResponseAdapter;
}());
exports.NextResponseAdapter = NextResponseAdapter;
//# sourceMappingURL=NextAdapter.js.map